import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CustomerGroupsTable from './CustomerGroupsTable';
import React from "react";
const CustomerGroupsListPage = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article swz-fixed-table-article", children: [_jsx("h2", { className: "article-title", children: "Customer Groups" }), _jsx(CustomerGroupsTable, {})] }) }));
};
export default CustomerGroupsListPage;
